<template>
	<div>
		<j-card class="mt4 bg5 pt2 pb2">
			<j-expendable-box :expand="false">
				<div slot="header" class="fs4 fw7 c1 p3 pt3 pb3">
					{{ $t("other_holders") }}
				</div>
				<div slot="body" class="p3">
					<div v-if="otherHolders.length">
						<div v-for="(holder, idx) in otherHolders" :key="idx">
							<core-entity-card
								:entity="holder"
								:hasActions="true"
								:pinnable="false"
								:isExpanded="false"
								class="mt4"
								@updated="refetchCase"
								@added="refetchCase"
								@deleted="refetchCase"
							>
								<!-- Header -->
								<div class="fs4 c1 pt3 pb3" slot="header">
									{{ $t("other_holder") + " " + (idx + 1) }}
								</div>

								<!-- Footer -->
								<div class="flex xs-12 xs-right mt6" slot="footer">
									<!-- TODO: make it work -->
									<j-button
										type="error"
										@click="removeHolder(holder.id)"
										size="small"
									>
										<crm-icon name="delete" color="c5" class="mr2" />Remove
									</j-button>
								</div>
							</core-entity-card>
						</div>
					</div>

					<!-- Select holder if there is not any -->
					<div class="bg5 pt4 pb4">
						<!-- Select a holder -->
						<div class="flex c6" v-if="!otherHolders.length">
							There is no other holder for this case
						</div>
						<j-button
							size="small"
							class="mt4"
							@click="$modal.show('addHolder')"
							type="primary"
							>Add Other Holder</j-button
						>
					</div>

					<!-- Modal -->
					<core-modal
						name="addHolder"
						headline="Select Entity"
						:pivotX="0"
						:pivotY="0"
						:hasHeader="false"
					>
						<div style="height:100vh; overflow: scroll;">
							<entity-picker
								@entity:selected="addOtherHolder($event)"
								:allowedEntityTypes="allowedEntityTypes"
							/>
						</div>
					</core-modal>
				</div>
				<!-- <div class="fs4 fw7 c1 pt3 pb3">
					{{ $t("other_holders") }}
				</div> -->
			</j-expendable-box>
		</j-card>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import CrmIcon from "@/components/CrmIcon"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard"
import EntityPicker from "../CaseForm/EntityPicker/EntityPicker"
import CoreModal from "@/modules/core/components/CoreModal"
import JExpendableBox from "@/components/JExpendableBox/"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JButton,
		EntityPicker,
		JCard,
		CrmIcon,
		CoreEntityCard,
		CoreModal,
		JExpendableBox
	},

	data() {
		return {
			allowedEntityTypes: ["individual", "company"]
		}
	},

	computed: {
		otherHolders() {
			const result = JSON.parse(
				JSON.stringify(
					this.$store.state.caseManagement?.case?.otherHolders || []
				)
			)
			return result
		}
	},

	methods: {
		refetchCase() {
			this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$store.state.caseManagement.caseId
			})
		},

		async addOtherHolder(payload) {
			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						status
						errors
					}
				}
			`

			const otherHolderIds = this.otherHolders.map(h => {
				return h.id
			})
			otherHolderIds.push(payload.id)

			console.log(otherHolderIds)

			const variables = {
				id: this.$store.state.caseManagement.caseId,
				input: {
					otherHolderIds
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateCase?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCase?.errors ||
							res?.data?.updateCase?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			} else {
				this.$modal.hide("addHolder")
			}

			this.refetchCase()
		},

		async removeHolder(holderId) {
			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						status
						errors
					}
				}
			`
			const otherHolderIds = this.otherHolders
				.map(h => {
					return h.id
				})
				.filter(id => {
					return id !== holderId
				})

			const variables = {
				id: this.$store.state.caseManagement.caseId,
				input: {
					otherHolderIds
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateCase?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCase?.errors ||
							res?.data?.updateCase?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			this.refetchCase()
		}
	}
}
</script>
